import { create } from "zustand";

interface IState {
  country: string | null;
  blockedState: string | null;
  setCountry: (country: string | null) => void;
  setBlockedState: (blockedState: string | null) => void;
}

export const useGeolocationStore = create<IState>(
  (set) => ({
    country: null,
    blockedState: null,
    setCountry: (country) => set(() => ({ country })),
    setBlockedState: (blockedState) => set(() => ({ blockedState }))
  }),
);
